import decode from 'jwt-decode'
import { app, talentTokenKey } from './feathers'

class AuthTalent {
  constructor() {
    this.domain = process.env.REACT_APP_API_URL || 'http://localhost:3000'
    this.serviceKey = 'authentication-talents'
  }

  async signup(data) {
    return app.service('talents').create(
      {
        id: data.id,
        password: data.password,
        isVerified: true,
      },
      { query: { companyId: data.companyId, createPassword: true } },
    )
  }

  async login(email, password) {
    try {
      const response = await app.service(this.serviceKey).create({
        strategy: 'local',
        email,
        password,
      })
      app.authentication.setAccessToken(response.accessToken)
      return response
    } catch (err) {
      throw new Error(err)
    }
  }

  async logout() {
    localStorage.clear()
    sessionStorage.clear()
    app.authentication.logout()
  }

  getToken() {
    return localStorage.getItem(talentTokenKey)
  }

  setToken(token) {
    localStorage.setItem(talentTokenKey, token)
  }

  decode(token) {
    return decode(token)
  }

  loggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken() // GEtting token from localstorage
    return !!token && !this.isTokenExpired(token) // handwaiving here
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token)
      if (decoded.exp < Date.now() / 1000) {
        // Checking if token is expired. N
        return true
      }
      return false
    } catch (err) {
      return false
    }
  }

  fetch(url, options) {
    // performs api calls sending the required authentication headers
    const headers = {
      // 'Accept': 'application/json',
      // 'Content-Type': 'application/json'
    }

    // Forcing if bearer is not here or expired to relog for any api calls
    if (this.loggedIn()) {
      headers.Authorization = `Bearer ${this.getToken()}`
    } else {
      window.location =
        `${process.env.REACT_APP_API_URL}/login` ||
        'http://localhost:3002/login'
    }

    return fetch(`${this.domain}${url}`, {
      headers,
      ...options,
    })
      .then(this._checkStatus)
      .then((response) => response.json())
      .then((res) => {
        if (res.accessToken) {
          this.setToken(res.accessToken)
          delete res.accessToken
        }
        return res
      })
  }
}

export default new AuthTalent()
